var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBellDuotone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell-duotone 1",
    clipPath: "url(#clip0_5223_4951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5974 17.5C12.5974 18.1641 12.3255 18.8008 11.8385 19.2695C11.3515 19.7383 10.69 20 10 20C9.31009 20 8.64856 19.7383 8.16155 19.2695C7.67453 18.8008 7.40262 18.1641 7.40262 17.5H10H12.5974Z",
    fill: "#000A66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M10.0001 0C9.28171 0 8.70136 0.558594 8.70136 1.25V2C5.7387 2.57812 3.50655 5.10156 3.50655 8.125V8.85938C3.50655 10.6953 2.80444 12.4688 1.53821 13.8438L1.23788 14.168C0.896975 14.5352 0.815806 15.0625 1.02279 15.5117C1.22977 15.9609 1.69649 16.25 2.20785 16.25H17.7923C18.3036 16.25 18.7663 15.9609 18.9773 15.5117C19.1884 15.0625 19.1031 14.5352 18.7622 14.168L18.4619 13.8438C17.1957 12.4688 16.4936 10.6992 16.4936 8.85938V8.125C16.4936 5.10156 14.2614 2.57812 11.2988 2V1.25C11.2988 0.558594 10.7184 0 10.0001 0Z",
    fill: "#000A66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5223_4951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBellDuotone);
export default __webpack_public_path__ + "static/media/ic-bell-duotone.20c5ea263c7a0fb7c6c58522ae66721f.svg";
export { ForwardRef as ReactComponent };